var e = { exports: {} };
export {
  e as __module
};
//# sourceMappingURL=utc.js.map
